import React, { useState, useEffect, useRef } from "react";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";

import { API } from "../../../backend";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";
import EditCompanyService from "../../../services/company/editCompanyService";
import { getTrans as t } from "../../../Localization/translations"
import ButtonLoading from "../../../components/Loder/buttonLoading";
import { IMAGE } from "../../../backend";

function EditProfile() {

const [successful, setSuccessful] = useState(false);
const [loading, setLoading] = useState(false)
const { register, handleSubmit,reset, formState: { errors } } = useForm();
const form = useRef();
const checkBtn = useRef();

const [email, setEmail] = useState("");
const [name, setName] = useState("");
const [company_name, setCompnayName] = useState("");
const [address, setAddress] = useState("");
const [country_name, setCountry] = useState([]);
const [country, setCountryid] = useState('');
const [state, setStateid] = useState('');
const [state_name, setState] = useState([]);
const [city, setCity] = useState("");
const [zip_code, setZipCode] = useState("");
const [phone_number, setPhoneNumber] = useState("");
const [currency, setcCurrency] = useState("");
const [locale, setLocale] = useState("");
const [my_id, setMy_id] = useState("");
const [user, setUser] = useState("");
const [image, setImage] = useState("");
const [grantaccesslogin, setGrantAccessLogin] = useState(true);

const getcountry = async () => {
  const res = await fetch(API + "helper/ajax/load-countries/");
  const getcon = await res.json();
  setCountry(await getcon);
}

useEffect(() => {
  getcountry();
  GetCompanyInfoService.getCompanyInfo().then(
    (response) => {
      setEmail(response.data.user_email)
      setName(response.data.name)
      setCompnayName(response.data.company_name)
      setAddress(response.data.address)
      setCountryid(response.data.country_name)
      setCity(response.data.city)
      setZipCode(response.data.zip_code)
      setPhoneNumber(response.data.phone_number)
      setcCurrency(response.data.currency)
      setCountryid(response.data.country)
      setStateid(response.data.state)
      setLocale(response.data.locale)
      setMy_id(response.data.my_id)
      setUser(response.data.user)
      setImage(response.data.image)
      setGrantAccessLogin(response.data.grant_login_access)

      reset({
        name: response.data.name,
        address: response.data.address,
        country_name: response.data.country,
        state: response.data.state,
        city: response.data.city,
        zipcode: response.data.zip_code,
        symbol: response.data.currency,
        locale: response.data.locale,
      })
    })
}, []);

const handlecountry = (event) => {
  const getcoutryid = event.target.value;
  setCountryid(getcoutryid);
  reset({
    country_name:getcoutryid
  })
}

const handlestate = (event) => {
  const getstateid = event.target.value;
  setStateid(getstateid)
  reset({
    state:getstateid
  })
}

useEffect(() => {
  const getstate = async () => {
    const resst = await fetch(API + "helper/ajax/load-states/" + country + "/");
    const getst = await resst.json();
    setState(await getst);
  }
  getstate();
}, [country]);

const handleCancle = () => {
  navigate("/profile")
}

let navigate = useNavigate()
const handleRegister = () => {
  setLoading(true)
  form.current.validateAll();
  if (checkBtn.current.context._errors.length === 0) {
    EditCompanyService.editCompanyProfile(
      email,
      name,
      company_name,
      address,
      country,
      state,
      city,
      zip_code,
      phone_number,
      currency,
      locale,
      my_id,
      user,
      grantaccesslogin
    ).then(
      (response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false)
          localStorage.setItem("locale",locale)
          setTimeout(() => {
            navigate("/profile")
          }, 2000)
          toast.success(`${response.data.response}`,{
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",})
        }
        else {
          toast.error(`${response.data.error}`,{
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",})
          setSuccessful(false);
          setLoading(false)
        }
      },
    )
  }
};

return (
<>
  <div className="page-wrapper">
    <ToastContainer />
    <div className="container-fluid">
      <div className="header pb-0 pt-3 mb-3">
        <div className="d-lg-flex">
          <div>
            <h5 className="mb-1">{t("Edit Profile")}</h5>
            <h6><Link to="/profile" className="tc" >{t("Settings")}</Link>  / <span >{t("Edit Profile")}</span></h6>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-3">
          <div className="">
            <div className="body">
              <div className="avatar avatar-xxl position-relative col-xl-12">
                {
                  // image !== null ? <img src={IMAGE + image} alt="Logo" className="profileimg shadow-sm" /> :
                  image !== null ? <img src={image} alt="Logo" className="profileimg shadow-sm" /> :
                    <img src={process.env.PUBLIC_URL + '/static/images/logo.png'} alt="Athena Fintech" className="logo  shadow-sm" style={{ maxWidth: '71%' }} />
                }
              </ div>
            </div>
          </div>
        </div>
        <div className="col-md-9">
          <div className="card">
            <div className="row">
              <div className="col-md-12">
                <div className="card-body">
                  <br />
                  <div className="row" style={{ margin: "0 auto" }}>
                    <Form role="form text-left"
                      onSubmit={handleSubmit(handleRegister)}
                      ref={form}
                      action="."
                      method="POST"
                      id="companyForm" >
                      {(
                        <>
                          <div className="form-group row">
                            <div className="col-xl-6">
                              <label className="col-form-label">{t("Company Name")} <Tooltip content={t("CompanyName_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                disabled
                                type="text"
                                name="companyname"
                                className="form-control"
                                value={company_name}
                                onChange={(e) => setCompnayName(e.target.value)}
                                placeholder="Company Name"
                              />
                            </div>

                            <div className="col-xl-6">
                              <label className="col-form-label required">{t("Name")} <Tooltip content={t("Name_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                type="text"
                                name="name"
                                className="form-control"
                                value={name}
                                placeholder="Name" 
                                {...register("name", { onChange: (e) => { setName(e.target.value) }, required: true })}
                                />
                          <div className="invalid-feedback">
                          {errors.name?.type === 'required' && "Name  is required"}
                        </div>
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="col-xl-6">
                              <label className="col-form-label required" htmlFor="email">{t("Email")} <Tooltip content={t("Email_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                disabled
                                type="email"
                                name="email"
                                className="form-control"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label className="col-form-label required">{t("Address")} <Tooltip content={t("Address_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              type="text"
                              name="address"
                              className="form-control"
                              value={address}
                              placeholder="Address"
                              {...register("address", { onChange: (e) => { setAddress(e.target.value) }, required: true })}
                              />
                          <div className="invalid-feedback">
                          {errors.address?.type === 'required' && "Address  is required"}
                        </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-xl-6">
                              <label className="col-form-label required">{t("Country")} <Tooltip content={t("Country_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <select
                                type="text"
                                className="form-control"
                                value={country}
                                name="country_name"
                                {...register("country_name", { onChange: (e) => { handlecountry(e) }, required: true })}
                                >
                                <option value="">---{t("Select Country")}---</option>
                                {
                                  country_name.map((countryget) => (
                                    <option key={countryget.id} value={countryget.id} >{countryget.name}</option>
                                  ))
                                }
                              </select>
                          <div className="invalid-feedback">
                          {errors.country_name?.type === 'required' && "Country  is required"}
                        </div>
                            </div>
                            <div className="col-xl-6">
                              <label className="col-form-label required">{t("State")} <Tooltip content={t("State_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <select
                                value={state}
                                className="form-control"
                                name="state"
                                {...register("state", { onChange: (e) => { handlestate(e) }, required: true })}
                              >
                                <option value="">---{t("Select State")}---</option>
                                {
                                  state_name.map((resst) => (
                                    <option key={resst.id} value={resst.id} >{resst.name}</option>
                                  ))
                                }
                              </select>
                          <div className="invalid-feedback">
                          {errors.state?.type === 'required' && "State  is required"}
                        </div>
                            </div>
                          </div>

                          <div className="form-group row">
                            <div className="col-xl-6">
                              <label className="col-form-label required">{t("City")} <Tooltip content={t("City_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                type="text"
                                name="city"
                                className="form-control"
                                value={city}
                                placeholder="City"
                                {...register("city", { onChange: (e) => { setCity(e.target.value) }, required: true })}

                              />
                                <div className="invalid-feedback">
                          {errors.city?.type === 'required' && "City  is required"}
                        </div>
                            </div>
                            <div className="col-xl-6">
                              <label className="col-form-label required">{t("Zip Code")} <Tooltip content={t("ZipCode_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                type="number"
                                name="zipcode"
                                className="form-control"
                                value={zip_code}
                                placeholder="Zip_Code"
                                {...register("zipcode", { onChange: (e) => { setZipCode(e.target.value) }, required: true })}

                              />
                                <div className="invalid-feedback">
                          {errors.zipcode?.type === 'required' && "Zipcode  is required"}
                        </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-xl-6">
                              <label className="col-form-label">{t("Phone Number")} <Tooltip content={t("PhoneNumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                type="number"
                                name="phonenumber"
                                className="form-control"
                                value={phone_number}
                                placeholder="Phone_Number"
                                onChange={(e) => setPhoneNumber(e.target.value)}
                              />
                            </div>
                            <div className="col-xl-6">
                              <label className="col-form-label required">{t("Currency")} <Tooltip content={t("Currency_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <select className="form-control" 
                                name="symbol"
                                value={currency}
                                {...register("symbol", { onChange: (e) => { setcCurrency(e.target.value) }, required: true })}

                              >
                                <option value="">---{t("Select Currency")}---</option>
                                <option value="USD" selected="selected">{t("USD")}</option>
                                <option value="EUR" selected="selected">{t("EUR")}</option>
                                <option value="GBP" selected="selected">{t("GBP")}</option>
                                <option value="CAD" selected="selected">{t("CAD")}</option>
                                <option value="AUD" selected="selected">{t("AUD")}</option>
                              </select>
                              <div className="invalid-feedback">
                          {errors.symbol?.type === 'required' && "Currency  is required"}
                        </div>
                            </div>
                          </div>

                          <div className="from-group">
                            <div className="col-xl-6">
                              <label className="col-form-label required">{t("Locale")} <Tooltip content={t("Locale_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <select className="form-control"
                                name="locale"
                                value={locale}
                                {...register("locale", { onChange: (e) => { setLocale(e.target.value) }, required: true })}

                              >
                                <option value="">---{t("Select Locale")}---</option>
                                <option value="en_US" selected="selected">{t("United States")}</option>
                                <option value="en_GB" selected="selected">{t("United Kingdom")}</option>
                                <option value="en_CA" selected="selected">{t("Canada")}</option>
                                <option value="en_IE" selected="selected">{t("Ireland")}</option>
                                <option value="en_AU" selected="selected">{t("Australia")}</option>
                                <option value="fr_CA" selected="selected">{t("Canada")}</option>
                                <option value="fr" selected="selected">{t("France")}</option>
                                <option value="de" selected="selected">{t("Germany")}</option>
                                <option value="nl_NL" selected="selected">{t("Dutch")}</option>
                                <option value="en_IN" selected="selected">{t("English (India)")}</option>
                              </select>
                              <div className="invalid-feedback">
                          {errors.locale?.type === 'required' && "Locale  is required"}
                        </div>
                            </div>
                            <div className="form-group mt-5 ">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                name="grantaccesslogin"
                                className="form-check-input"
                                id="grantaccesslogin"
                                checked={grantaccesslogin}
                                onChange={(e) => setGrantAccessLogin(e.target.checked)}
                              />
                              <label className="col-form-label" htmlFor="grantaccesslogin">
                                {t("Grant Login Access to Athena Fintech")}
                              </label>
                            </div>
                          </div>
                          </div>
                          <br /><br />
                          <div className="form-group">
                            <button type="button" className="btn-save border-0 btn btn-secondary btn-gradient-primary btn-md" onClick={handleCancle}><b>{t("Cancel")}</b></button>&nbsp;
                            <button type="submit" className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"><b>
                              {
                                loading === false ? (
                                  // t('Save')
                                  t('Update')
                                ) : (
                                  <ButtonLoading />
                                )
                              }
                            </b></button>
                          </div>
                        </>
                      )}
                      <CheckButton style={{ display: "none" }} ref={checkBtn} />
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>
)
}

export default EditProfile